<template>
  <div
    class="d-flex pa-2 full-width overflow-hidden flex-md-row"
    v-on="$listeners"
  >
    <v-avatar color="#F4F7FA" size="100">
      <v-img
        :src="item.image_url"
        :lazy-src="item.image_url"
        :aspect-ratio="1"
        min-width="100"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-avatar>
    <div
      class="pl-4 pb-2 pr-4 flex-grow-1 d-flex flex-column full-width overflow-hidden"
    >
      <div
        class="font-weight-bold text-h5 text-truncate full-width"
        :title="item.name"
      >
        {{ item.name }}
      </div>
      <div class="d-flex align-center">
        <span>{{ item.layers_count }} {{ $t('layergroup.layer.name') }}</span>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong class="ng-binding">{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <div class="mt-auto">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    workspace: { type: Object, default: () => ({}) },
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    item() {
      return this.value
    },
  },
}
</script>

<style scoped></style>
